import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { DocumentLine } from '@dato-proxy/entities/documentline.entity';
import { BaseComponent } from '@m4u-angular/base/component/BaseComponent';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { BaseState } from '@m4u-angular/base/entities/BaseEntities';
import { DxListComponent } from 'devextreme-angular';

class State extends BaseState {
    SelectedLineIDs: number[];
    TotalAmount: number;
    DocumentLinesState: any = {};
}

@Component({
    providers: ServiceBagServices,
    selector: 'app-document-line-list',
    templateUrl: './document-line-list.component.html',
    styleUrls: ['./document-line-list.component.scss']
})
export class DocumentLineListComponent extends BaseComponent<State> {

    @Input() DocumentLines: DocumentLine[];
    @Output() SelectionChanged: EventEmitter<DocumentLine[]> = new EventEmitter<DocumentLine[]>();

    @ViewChild(DxListComponent) list: DxListComponent;

    constructor(A: ServiceBagService) {
        super(A, 'DocumentLineListComponent', State);
    }

    override OnInitComponentFinished() {
        super.OnInitComponentFinished();
        this.State.SelectedLineIDs = this.DocumentLines.filter(x => x.IsOpen).map(x => (x as any).LineID);
    }

    OnSelectionChanged(e) {
        const documentLines = this.list.instance.option('selectedItems');
        this.SelectionChanged.emit(documentLines as DocumentLine[]);
        this.State.TotalAmount = (documentLines as DocumentLine[]).map(x => x.TotalSum).reduce((sum, current) => sum + current, 0);
    }

    get Currency() {
        return this.DocumentLines?.length && this.DocumentLines[0].Currency;
    }

    ToggleDocumentLine(event: any, item: any) {
        this.State.DocumentLinesState[item.LineID] = !this.State.DocumentLinesState[item.LineID];

        if (event) {
            event.preventDefault();
            event.stopPropagation();

            const listItemElement = this.FindListItemElement(event.srcElement);
            if (this.State.DocumentLinesState[item.LineID]) listItemElement.classList.add('opened');
            else listItemElement.classList.remove('opened');
        }
    }

    private FindListItemElement(element: HTMLElement): HTMLElement {
        const parent = element.parentElement;
        if (parent.classList.contains('dx-list-item')) return parent;

        return this.FindListItemElement(parent);
    }

}
